import LP from '../0-lp';
import $ from 'jquery';

LP.mailingjobsPage = {
    reloadInterval: null,
    init: function () {
        LP.dlgMailJob.prepare('a[dialog="mailingjob"]', {
            afterSubmit: function () {
                LP.mailingjobsPage.reload();
            }
        });

        var pollId = $('#pollId').val();
        var mailings = $('#lp-widget-mailings');
        if (LP.mailingjobsPage.reloadInterval) clearInterval(LP.mailingjobsPage.reloadInterval);
        if (pollId && mailings.length != 0) LP.mailingjobsPage.reloadInterval = setInterval('LP.mailingjobsPage.reload()', 10000);

        LP.mailingjobsPage.cbReload();
    },

    cbReload: function (json) {
        if (!json) clearInterval(LP.mailingjobsPage.reloadInterval);
        $('#lp-widget-mailings a[action="pagechange"]').click(LP.mailingjobsPage.pagechange);

        $('#lp-widget-mailings a[action="cancelMailingjob"]').click(LP.mailingjobsPage.cancelJob);
        //This is not a bug, they do the same thing, so we can call the same method
        $('#lp-widget-mailings a[action="removeMailingjob"]').click(LP.mailingjobsPage.cancelJob);

        $('#lp-widget-mailings select[action="changePageSize"]').change(LP.mailingjobsPage.changeSize);
    },

    reload: function () {
        var pollId = $('#pollId').val();
        if (pollId) LP.mailingjobsPage.reloadMailings('backend/getMailingJobsTable/', 'poll=' + pollId);
    },

    changeSize: function () {
        var pollId = $('#pollId').val();
        if (pollId) LP.mailingjobsPage.reloadMailings('backend/getMailingJobsTable/', 'poll=' + pollId + '&size=' + $(this).val());
    },

    pagechange: function () {
        if ($(this).is('[disabled]')) return false;
        LP.mailingjobsPage.reloadMailings($(this).attr('url'), $(this).attr('url_params'));
        return false;
    },

    reloadMailings: function (url, params) {
        $('#loader-holder').timedLoader(1);
        window.Browser.loadHTML($('#lp-widget-mailings'), url, params, LP.mailingjobsPage.cbReload, function () {
            clearInterval(LP.mailingjobsPage.reloadInterval);
        });
    },

    cancelJob: function () {
        if ($(this).is('[disabled]')) return;
        var url = $(this).attr('url');
        var params = $(this).attr('url_params');
        LP.UI.warnConfirm($(this), function () {
            window.Browser.send(url, params, function (json) {
                $('#lp-widget-mailings').html(json.table);
                LP.mailingjobsPage.reload();
            });
        });
        return false;
    },

    beforeLeaving: function () {
        clearInterval(LP.mailingjobsPage.reloadInterval);
        return true;
    }
};